import React from "react"
import { Outlet } from "react-router-dom"

import Actions from "../../components/Configuration/Actions/Actions"
import useSiteTitle from "../../hooks/use-site-title"
import Header from "../Header/Header"

import styles from "./ConfiguratorLayout.module.scss"

const ConfiguratorLayout = () => {
  const siteTitle = useSiteTitle(false)

  const title = siteTitle

  return (
    <div className={[styles.content].join(" ").trim()}>
      {/* Main header */}
      <Header
        data={{
          titulo: title,
        }}
      ></Header>

      {/* Main content */}
      <main className={styles.main}>
        <Outlet />
      </main>
      <Actions />
    </div>
  )
}

export default ConfiguratorLayout
